var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [_vm.defaultView ? _c("DocList") : _c("FileExplorer")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }